module.exports = __webpack_public_path__ + "static/img/fingerpost_order_1.d41192f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_order_1.jpg
// module id = ABnX
// module chunks = 0